export enum TabView {
  transparent = 'transparent',
  filled = 'filled',
}
